// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    riskModels: "Risk Models",
    title: "Risk Models",
    subtitle: "Configure risk assessment matrices with time horizons, risk levels, and scores.",
    documentation: "Documentation",
    description:
      "Create risk assessment models with custom time horizons, risk levels, and scoring.",
    createRiskModel: "Create Risk Model",
  },
  nb_NO: {
    settings: "Innstillinger",
    riskModels: "Risikomodeller",
    title: "Risikomodeller",
    subtitle: "Konfigurer risikovurderingsmatriser med tidshorisonter, risikonivåer og poeng.",
    documentation: "Dokumentasjon",
    description:
      "Opprett risikovurderingsmodeller med tilpassede tidshorisonter, risikonivåer og poengberegning.",
    createRiskModel: "Opprett risikomodell",
  },
} as const;
